/* eslint-disable max-len */
export const RegistrationModalOpen = "/user/register";
export const User = { url: "/api/user/%7Baction%7D", type: undefined as { action: string | number; } };
